<template>
  <section class="search-query">
    <label>{{ label }} <span v-if="dateUpdate !== undefined">({{ dateUpdate }})</span></label>
    <b-button size="sm" v-if="!isCopyToClipboard" class="but-copy" v-on:click="setToClipboard">
      Копировать
    </b-button>
    <b-button v-if="update !== undefined" size="sm" class="mr-1 but-copy" v-on:click="update">
      Обновить
    </b-button>
    <b-card class="search-card">
      <b-textarea v-model="clipboardText" v-if="isCopyToClipboard" ref="clipboardRef"></b-textarea>
      <b-container fluid v-if="!isCopyToClipboard">
        <b-row v-for="ruQuery in searchQueries" v-bind:key="ruQuery.id">
          <b-col class="search-name-box">
            <b-container fluid>
              <b-row>
                <b-col cols="7" class="text-left">
                  <i
                      v-if="isEditQueries[ruQuery.id] == undefined || !isEditQueries[ruQuery.id]"
                      v-on:click="editQueries(ruQuery.id)"
                  >{{ ruQuery.query }}</i>
                  <b-input
                      v-model="searchQueries[ruQuery.id]['query']"
                      v-show="isEditQueries[ruQuery.id] != undefined && isEditQueries[ruQuery.id]"
                      v-on:change="editQueries(ruQuery.id, true)"
                      :ref="'editQueries_'+ ruQuery.id"
                      size="sm"
                      class="mb-1"
                      v-if="searchQueries[ruQuery.id] != undefined"
                      v-on:focusout="handleFocusout(ruQuery.id)"
                  ></b-input>
                  <label class="red-text" v-if="duplicateQueriesEdit[ruQuery.id]">дубликат</label>
                </b-col>
                <b-col v-if="existPhrase" cols="2" class="text-right">{{ nFormat(ruQuery.generalFrequency) }}</b-col>
                <b-col :cols="existPhrase ? 2 : 4" class="text-right">{{ nFormat(ruQuery.frequency) }}</b-col>
                <b-col cols="1">
                  <button type="button" class="but-remove close b-form-tag-remove ml-1"
                          v-on:click="queryDelete(ruQuery.id)"
                          v-if="isEditQueries[ruQuery.id] == undefined || !isEditQueries[ruQuery.id]"
                  >×
                  </button>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
        <b-row align-h="center" class="mt-2 ml-2 mr-1">
          <b-col>
            <label class="duplicate-label red-text" v-if="duplicateQueries">дубликат</label>
            <b-textarea
                size="sm"
                class="mb-2 query-input"
                rows="1"
                v-model="newQueries"
                v-on:change="addNewQuery"
                placeholder="Введите запрос"
            >
            </b-textarea>
            <button type="button" class="but-add-queries but-remove close b-form-tag-remove ml-1">+</button>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </section>
</template>

<script>
export default {
  name: "SearchQuery",
  props: {
    searchQueries: Object,
    label: String,
    change: Function,
    update: Function,
    dateUpdate: String,
    existPhrase: Boolean,
    typeRu: Boolean
  },
  data() {
    return {
      isEditQueries: {},
      newQueries: null,
      duplicateQueries: false,
      clipboardText: '',
      isCopyToClipboard: false,
      duplicateQueriesEdit: {},
    }
  },
  methods: {
    getMaxKey: function (object) {
      let maxKey = -1;
      for (let key in object) {
        if (parseInt(key) > maxKey) {
          maxKey = key;
        }
      }
      return maxKey;
    },
    addNewQuery: function () {
      let maxKey = this.getMaxKey(this.searchQueries);
      maxKey++;
      let newKey = maxKey;
      let queriesSplit = this.newQueries.split("\n");
      queriesSplit.forEach((val) => {
        if (val && val.trim() != '') {
          let tabSplit = val.split("\t");
          if (this.duplicateCheck(tabSplit[0])) {
            this.duplicateQueries = false
            return
          }
          let generalFrequency = 0;
          let frequency = 0;
          if (tabSplit.length > 1) {
            generalFrequency = tabSplit[1];
          }
          if (tabSplit.length == 3) {
            frequency = tabSplit[2];
          }
          this.$set(this.searchQueries, newKey, {
            id: newKey,
            generalFrequency: generalFrequency,
            frequency: frequency,
            query: tabSplit[0],
            isNew: true
          });
          newKey++;
        }
      });
      this.newQueries = null;
      this.change();
    },
    editQueries: function (id, isStop = false) {
      if (isStop === false) {
        for (let key in this.duplicateQueriesEdit) {
          if (this.duplicateQueriesEdit[key]) {
            return false
          }
        }
      }
      if (isStop && this.duplicateCheck(this.searchQueries[id]['query'], id)) {
        this.$forceUpdate()
        return false;
      }
      for (let key in this.isEditQueries) {
        this.$set(this.isEditQueries, key, false);
      }

      this.$set(this.isEditQueries, id, !isStop);
      this.$nextTick(() => {
        if (isStop) {
          this.change();
        }
        this.$refs['editQueries_' + id][0].focus();
      });
    },
    queryDelete: async function (id) {
      for (let key in this.searchQueries) {
        if (key == id) {
          let buf = this.searchQueries;
          delete buf[key];
          this.$forceUpdate();
        }
      }
      this.change();
    },
    duplicateCheck: function (query, id = false) {
      let queriesSplit = query.split("\n");
      // self check
      for (let qKey1 in queriesSplit) {
        for (let qKey2 in queriesSplit) {
          let tabSplit1 = queriesSplit[qKey1].split("\t");
          let tabSplit2 = queriesSplit[qKey2].split("\t");
          if (tabSplit1[0] == tabSplit2[0] && qKey1 != qKey2) {
            this.duplicateQueries = true;
            return true;
          }
        }
      }
      for (let qKey in queriesSplit) {
        let tabSplit = queriesSplit[qKey].split("\t");
        for (let key in this.searchQueries) {
          if ((id != key || !id) && tabSplit[0] == this.searchQueries[key].query) {
            if (id !== false) {
              this.duplicateQueriesEdit[id] = true;
            } else {
              this.duplicateQueries = true;
            }

            return true;
          } else {
            if (id !== false) {
              this.duplicateQueriesEdit[key] = false;
            }
          }
        }
      }
      this.duplicateQueries = false;
      return false;
    },
    setToClipboard: async function () {
      this.clipboardText = '';
      this.isCopyToClipboard = true;
      await this.$nextTick();
      for (let key in this.searchQueries) {
        let val = this.searchQueries[key];
        this.clipboardText += val.query + "\t" + val.generalFrequency + "\t" + val.frequency + "\n";
      }
      await this.$nextTick();
      let textareaEl = this.$refs.clipboardRef.$el;
      textareaEl.select();
      textareaEl.setSelectionRange(0, 99999);
      try {
        document.execCommand('copy');
      } catch (err) {
        alert('Oops, unable to copy');
      }
      /* unselect the range */
      window.getSelection().removeAllRanges();
      this.isCopyToClipboard = false;
    },
    handleFocusout: function (id) {
      if (!this.duplicateCheck(this.searchQueries[id]['query'], id)) {
        this.isEditQueries[id] = false
      } else {
        this.$nextTick(() => {
          this.$refs['editQueries_' + id][0].focus();
        });
        return false;
      }
    },
  },
  mounted() {

  }
}
</script>

<style scoped>
.search-link-box.col-4 {
  flex: 0 0 30%;
  max-width: 30%;
}

.search-name-box.col-8 {
  flex: 0 0 70%;
  max-width: 70%;
}

.search-query button.but-remove:focus {
  outline: none;
}

/*.query-aria::-webkit-scrollbar {*/
/*    display: none;*/
/*}*/
/*.query-aria {*/
/*    -ms-overflow-style: none;  !* IE and Edge *!*/
/*    scrollbar-width: none;  !* Firefox *!*/
/*}*/

.search-query .query-input {
  height: 34px;
  width: 91%;
  margin-right: 5px;
  display: inline-block;
}

.but-add-queries {
  line-height: 34px;
}

.box-but-copy {
  text-align: right;
  margin-top: -8px;
  padding-right: 2px;
  margin-right: -9px;
  margin-bottom: 13px;
  position: sticky;
  top: 10px;
  z-index: 999;
  background: white;
  padding-top: 0;
  padding-bottom: 10px;
  border-bottom: 2px solid;
}

.but-copy {
  float: right;
  margin-bottom: 5px;
}

label {
  text-align: left;
  margin: 0;
  float: left;
}

.search-card {
  width: 100%;
  max-height: 370px;
  overflow-y: auto;
}

.duplicate-label {
  margin-left: 32px;
  color: grey;
}

.red-text {
  color: red;
}
</style>